import { createTheme } from 'widget_main/globals/themes';
import { isBrowserIE } from 'polyfills/helpers';
import sizings from 'widget_main/styles/sizings.scss';
import { MessageCallbackResponse } from 'core_main/sdk/send_message/types';
import { InitCallbackResponse } from 'core_main/sdk/init/types';

const WIDGET_OPEN_ANIMATION = 'width 250ms, height 250ms';

const selfIframe = window.parent.document.getElementById(
  'kustomer-ui-sdk-iframe',
) as HTMLFrameElement;
export const setThemeVariables = (
  settings: InitCallbackResponse['settings'],
) => {
  const theme = createTheme(settings);

  if (isBrowserIE()) {
    return import(
      /* webpackChunkName: "css-vars-ponyfill" */ 'css-vars-ponyfill'
    ).then((module) => {
      module.default({
        variables: (theme as unknown) as { [key: string]: string },
      });
    });
  }
  Object.entries(theme).forEach((value) => {
    const variable = value[0];
    const style = value[1];
    document.documentElement.style.setProperty(variable, style);
  });
  return Promise.resolve();
};

export const setIframeSizeFullScreen = () => {
  selfIframe.style.transition = WIDGET_OPEN_ANIMATION;
  selfIframe.style.width = '100%';
  selfIframe.style.height = '100%';
  selfIframe.style.bottom = '0';
  selfIframe.style.right = '0';
};

export const setIframeSizeDefaultWidget = () => {
  selfIframe.style.transition = WIDGET_OPEN_ANIMATION;
  selfIframe.style.width = sizings.widgetFrameWidth;
  selfIframe.style.height = sizings.widgetFrameHeight;
  selfIframe.style.bottom = '20px';
  selfIframe.style.right = '20px';
};

export const setIframeSizeHidden = () => {
  selfIframe.style.transition = 'none';
  selfIframe.style.width = '0px';
  selfIframe.style.height = '0px';
  selfIframe.style.bottom = '20px';
  selfIframe.style.right = '20px';
};

export const setIframeSizeChatIcon = (isChatIconHidden?: boolean) => {
  if (isChatIconHidden) {
    setIframeSizeHidden();
    return;
  }

  selfIframe.style.transition = 'none';
  selfIframe.style.width = sizings.chatIconFrameWidth;
  selfIframe.style.height = sizings.chatIconFrameHeight;
  selfIframe.style.bottom = '20px';
  selfIframe.style.right = '20px';
};

export const sortByMessageTimestamps = (
  messageIds: string[],
  allMessagesData: Record<string, MessageCallbackResponse>,
) => {
  return messageIds.slice().sort((firstId, secondId) => {
    const firstMsg = allMessagesData[firstId];
    const secondMsg = allMessagesData[secondId];

    const firstDate = new Date(firstMsg.createdAt);
    const secondDate = new Date(secondMsg.createdAt);
    return firstDate < secondDate ? -1 : 1;
  });
};
